import * as React from 'react';
import MUIChip from '@material-ui/core/Chip';
import styled from 'styled-components';
import { Uds } from '../../types';

const StyledChip = styled(MUIChip)`
  &.MuiChip-root {
    color: ${(props) => props.theme.colorOnPrimary};
    border-radius: 4px;
    border: 1px solid transparent;
    height: ${(props) => (props.size === 'small' ? '16px' : '20px')};
    font-weight: 500;
  }

  .MuiChip-label {
    font-size: 12px;
    padding: 2px 8px;
    line-height: 12px;
  }

  .MuiChip-icon {
    width: 16px;
    height: 16px;
    color: ${(props) => props.theme.colorOnPrimary};
  }
  .MuiChip-deleteIcon {
    color: ${(props) => props.theme.colorOnPrimary};
    width: 16px;
    height: 16px;
  }

  .MuiChip-labelSmall {
    font-size: 10px;
    line-height: 10px;
  }

  .MuiChip-iconSmall {
    width: 14px;
    height: 14px;
    color: ${(props) => props.theme.colorOnPrimary};
  }
  .MuiChip-deleteIconSmall {
    color: ${(props) => props.theme.colorOnPrimary};
    width: 14px;
    height: 14px;
    padding: 0;
  }

  &.utuds-black.utuds-dark {
    background-color: ${(props) => props.theme.colorInverseSurface};
    color: ${(props) => props.theme.colorInverseOnSurface};
  }
  &.utuds-grey.utuds-dark {
    background-color: ${(props) => props.theme.paletteNeutralVariant30};
  }
  &.utuds-orange.utuds-dark {
    background-color: ${(props) => props.theme.colorWarning};
    color: ${(props) => props.theme.colorOnWarning};
  }
  &.utuds-green.utuds-dark {
    background-color: ${(props) => props.theme.colorSuccess};
    color: ${(props) => props.theme.colorOnSuccess};
  }
  &.utuds-blue.utuds-dark {
    background-color: ${(props) => props.theme.colorPrimary};
    color: ${(props) => props.theme.colorOnPrimary};
  }
  &.utuds-red.utuds-dark {
    background-color: ${(props) => props.theme.colorAlert};
    color: ${(props) => props.theme.colorOnAlert};
  }

  &.utuds-light {
    color: ${(props) => props.theme.paletteNeutralVariant20};
    .MuiChip-icon {
      color: ${(props) => props.theme.paletteNeutralVariant20};
    }
    .MuiChip-deleteIcon {
      color: ${(props) => props.theme.paletteNeutralVariant20};
    }
  }

  &.utuds-black&.utuds-light {
    background-color: ${(props) => props.theme.colorInverseSurface};
    color: ${(props) => props.theme.colorInverseOnSurface};
    border: 1px solid ${(props) => props.theme.paletteNeutralVariant20};

    .MuiChip-icon {
      color: ${(props) => props.theme.colorOnPrimary};
    }
    .MuiChip-deleteIcon {
      color: ${(props) => props.theme.colorOnPrimary};
    }
  }
  &.utuds-grey&.utuds-light {
    background-color: ${(props) => props.theme.colorSurfaceVariant};
  }

  &.utuds-orange&.utuds-light {
    background-color: ${(props) => props.theme.colorWarningContainer};
    color: ${(props) => props.theme.colorOnWarningContainer};
  }

  &.utuds-green&.utuds-light {
    background-color: ${(props) => props.theme.colorSuccessContainer};
    color: ${(props) => props.theme.colorOnSuccessContainer};
  }

  &.utuds-blue&.utuds-light {
    background-color: ${(props) => props.theme.colorPrimaryContainer};
    color: ${(props) => props.theme.colorOnPrimaryContainer};
  }

  &.utuds-red&.utuds-light {
    background-color: ${(props) => props.theme.colorAlertContainer};
    color: ${(props) => props.theme.colorOnAlertContainer};
  }
`;

export type PillProps = Uds<{
  text: React.ReactNode;
  variant?: 'black' | 'grey' | 'orange' | 'green' | 'blue' | 'red';
  size?: 'small' | 'medium';
  primary?: boolean;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  onRightIconClick?(): void;
  clickable?: boolean;
  onClick?(): void;
  style?: React.CSSProperties;
  className?: string;
}>;

export const Pill: React.FC<React.PropsWithChildren<PillProps>> = ({
  text,
  variant,
  primary = false,
  leftIcon,
  size = 'medium',
  clickable = false,
  rightIcon,
  onClick,
  onRightIconClick,
  dataTest,
  style,
  className
}) => (
  <StyledChip
    data-test={dataTest}
    className={`utuds-${variant} ${primary ? 'utuds-dark' : 'utuds-light'} ${className}`}
    icon={leftIcon}
    label={text}
    size={size}
    style={style}
    onDelete={onRightIconClick}
    clickable={clickable}
    onClick={onClick}
    deleteIcon={rightIcon}
  />
);

export default Pill;
